import { Outlet } from "react-router-dom";
import {
  Box,
  Paper,
  Container,
  Chip,
  Stack,
  Link,
  useTheme,
  Card,
} from "@mui/material";
import ThemeToggle from "../components/ThemeToggle";
import { APP_CONFIG } from "../utils/constants";
import { Logo, SkewbLogo } from "../../assets";
import loginBackground from "../../assets/bg2.webp";

export const AuthLayout = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        bgcolor: { xs: "background.default", md: "transparent" },
      }}
    >
      {/* Left Panel - Background Image */}
      <Box
        sx={{
          p: 2,
          flex: 1,
          display: { xs: "none", md: "block" },
        }}
      >
        <Paper
          variant="outlined"
          data-background-elevation={1}
          sx={{
            width: "100%",
            height: "100%",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            opacity: theme.palette.mode === "dark" ? 0.4 : 1,
            border: "0px",
            borderRadius: "10px",
            backgroundImage: `url(${loginBackground})`,
          }}
        ></Paper>
      </Box>

      {/* Right Panel - Content */}
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          bgcolor: "background.default",
          maxWidth: { xs: "100%", lg: "40%" },
        }}
      >
        {/* Header */}
        <Box
          sx={{
            p: { xs: 2, md: 3 },
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: { xs: "center", md: "flex-start" },
            }}
          >
            <Logo />
            <Chip
              label={APP_CONFIG.name}
              color="primary"
              size="small"
              variant="outlined"
              sx={{
                ml: 1,
              }}
            />
          </Box>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <ThemeToggle />
          </Box>
        </Box>

        {/* Main Content */}
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            px: { xs: 3, md: 6 },
            py: { xs: 2, md: 4 },
          }}
        >
          <Container
            maxWidth="sm"
            sx={{
              px: { xs: 0, md: 2 },
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Card
              variant="outlined"
              sx={{
                p: 4,
                maxWidth: { xs: "100%", lg: 500 },
                position: "relative",
                width: "100%",
              }}
            >
              <Outlet />
            </Card>
          </Container>
        </Box>

        <Box
          sx={{
            p: { xs: 2, md: 3 },
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            justifyContent: "space-between",
            alignItems: "center",
            gap: { xs: 2, md: 0 },
          }}
        >
          <Stack
            direction="row"
            spacing={2}
            justifyContent="center"
            sx={{ order: { xs: 2, md: 1 } }}
          >
            <Link href="#" color="text.secondary" variant="body2">
              Help
            </Link>
            <Link href="#" color="text.secondary" variant="body2">
              Privacy
            </Link>
            <Link href="#" color="text.secondary" variant="body2">
              Terms and Conditions
            </Link>
          </Stack>
          <Box
            sx={{
              order: { xs: 1, md: 2 },
              color: "text.secondary",
              maxWidth: "112px",
            }}
          >
            <SkewbLogo />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
